const isLocalHostName = (hostname) =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '0.0.0.0';

const getDefaultWatchtowerBase = () => {
  const defaultBackend = 'https://fqeinsights.xyz';

  if (typeof window === 'undefined') {
    return defaultBackend;
  }

  return isLocalHostName(window.location.hostname)
    ? '/watchtower-api'
    : defaultBackend;
};

export const API_URL =
  process.env.REACT_APP_API_URL || 'https://api.fqeanalytics.xyz';

export const WATCHTOWER_API_URL =
  process.env.REACT_APP_WATCHTOWER_API_URL || getDefaultWatchtowerBase();
// plans to migrate to this fully in the future
export const COMPETITION_API_URL = 'https://fqeinsights.xyz';
